@for (toast of toasts$ | async; track toast; let i = $index) {
  <div @verticalCollapse @triggerChildAnimation>
    <ui-toast [toast]="toast" (closeToast)="close(i)" />
  </div>
}
